import React, { useContext, useState } from 'react'
import { PublicIndexContext } from '../context/PublicIndexContext'
import '../App.css'
import BankIDSign from './BankIDSign'
import { BankIdSigningActions } from '../helpers/Constants.js'
import { isMobile } from 'react-device-detect'

const PowerOfAttorney = () => {
  const publicIndexContext = useContext(PublicIndexContext)
  const [showSign, setShowSign] = useState(false)
  const [signAction, setSignAction] = useState(null)

  const QRCodeButton = () => {
    return (
      <button type="button" className="btn btn-primary bankid-button"
        onClick={() => { setShowSign(true); setSignAction(BankIdSigningActions.QR_CODE) }}>
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-qr-code-scan" viewBox="0 0 16 16">
          <path d="M0 .5A.5.5 0 0 1 .5 0h3a.5.5 0 0 1 0 1H1v2.5a.5.5 0 0 1-1 0zm12 0a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0V1h-2.5a.5.5 0 0 1-.5-.5M.5 12a.5.5 0 0 1 .5.5V15h2.5a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5m15 0a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1 0-1H15v-2.5a.5.5 0 0 1 .5-.5M4 4h1v1H4z"/>
          <path d="M7 2H2v5h5zM3 3h3v3H3zm2 8H4v1h1z"/>
          <path d="M7 9H2v5h5zm-4 1h3v3H3zm8-6h1v1h-1z"/>
          <path d="M9 2h5v5H9zm1 1v3h3V3zM8 8v2h1v1H8v1h2v-2h1v2h1v-1h2v-1h-3V8zm2 2H9V9h1zm4 2h-1v1h-2v1h3zm-4 2v-1H8v1z"/>
          <path d="M12 9h2V8h-2z"/>
        </svg>
        <span>
          &nbsp;Signera på annan enhet
        </span>
      </button>
    )
  }

  const BankIDButton = () => {
    if (isMobile) {
      return (
        <button className="btn btn-primary bankid-button"
          onClick={() => { setShowSign(true); setSignAction(BankIdSigningActions.MOBILE) }}>
          <img src="/images/BankID_logo.png" className='img-fluid' alt="BankId Icon" />
          <span style={{ verticalAlign: '-0.125em' }}>
            Signera
          </span>
        </button>
      )
    }
  }

  if (showSign) {
    return <BankIDSign signAction={signAction} />
  }

  return (
    <div className="container">
      <div className="row">
        <div className="col-xs-6 offset-xs-4 col-14">
          <div className="text-center mt-5">
            {publicIndexContext.formHeadingTextBeforeSigning}
          </div>
          <div className="mt-5 border rounded p-1"
            dangerouslySetInnerHTML={{
              __html: atob(publicIndexContext.unSignedPowerOfAttorney.file)
            }}>
          </div>
          <div style={{ marginTop: '1em', marginBottom: '1em' }}>
            <div className="row mt-2">
              <div className="col-12 text-center">
                <BankIDButton />
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-12 text-center" style={{ marginTop: '0.5em' }}>
                <QRCodeButton />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PowerOfAttorney
